import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Table,
  CardBox,
  DropdownButton,
  SearchWithAction,
  EmptyState,
  Page,
  FormSelect,
} from "../../components";
import { push } from "../../actions/nav-actions";
import { fetchStudyCases, deleteProject } from "../../api";
import { copy, notify, showFile, testRegex } from "../../utils";
import { Constants } from "../../defaults";
import Loader from "../../components/Loader";


class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studycases: [],
      query: {
        organizations: [],
      },
      search: "",
      loading: false,
    };
  }
  componentDidMount() {
    this.fetchData();
  }
  fetchData = async () => {
    this.setState({ loading: true });
    const result = await fetchStudyCases(this.props.user.token);
    this.setState({ studycases: result.studycases });
    this.setState({ loading: false });
  };
  renderEmpty = () => {
    return (
      <EmptyState
        title="Empty Study Cases"
        message="Nothing to show to you here, maybe change your search or reload the page."
      />
    );
  };
  renderChild() {
    return [
      { Header: "Project", accessor: "name" },
      { Header: "Code", accessor: "code" },
      {
        Header: "Brief Description",
        accessor: "description",
      },
      {
        Header: "Projected dates",
        id: "cellDates",
        accessor: (d) => new Date(d.created_at).toLocaleDateString(),
      },
      {
        Header: "Organization",
        accessor: "organization",
      },
      {
        Header: "Status",
        id: "status",
        accessor: (d) => (!!d.status ? d.status : "not defined"),
      },
      {
        Header: "Country",
        id: "cellLocations",
        accessor: "geolocation.country",
      },
      {
        Header: "Options",
        accessor: (d) => d,
        className: "no-overflow",
        id: "options",
        Cell: (props) => (
          <DropdownButton
            onActionClick={() => {}}
            icon="mdi mdi-account-box"
            label="Options"
          >
           {
            this.props.user.is_admin && ( <DropdownButton.Option
              onClick={() =>
                this.props.push(
                  `/projects/${props.value.organization}/${props.value.code}`
                )
              }
              icon="mdi mdi-pencil"
              label="Edit"

            />
            )
           }
            <DropdownButton.Option
              onClick={() =>
                copy(props.value.code, (text) =>
                  notify("Copy code", "Code [" + text + "] copied!")
                )
              }
              icon="mdi mdi-layers"
              label="Copy code"
            />
            <DropdownButton.Option
              onClick={() => {
                fetch(
                  `${Constants.API_URL}/v1/me/organizations/${props.value.organization}/projects/${props.value.code}/pdf`,
                  {
                    headers: {
                      Authorization: `Baerer ${this.props.user.token}`,
                    },
                  }
                )
                  .then((r) => r.blob())
                  .then((blob) =>
                    showFile(
                      blob,
                      `${props.value.organization}-${props.value.code}`
                    )
                  );
              }}
              icon="mdi mdi-download"
              label="Download PDF"
            />
            {this.props.user.is_admin && (<DropdownButton.Option
              onClick={() => {
                let confirm = window.confirm(
                  "Really wants to delete project " + props.value.code + "?"
                );
                if (confirm) {
                  deleteProject(
                    this.props.user.token,
                    props.value.organization,
                    props.value.code
                  )
                    .then((project) => this.fetchData())
                    .catch((err) => notify(err.message));
                }
              }}
              icon="mdi mdi-delete"
              label="Delete"
            />)}
          </DropdownButton>
        ),
      },
    ];
  }
  render() {
    let results = this.state.studycases.filter((i) =>
      testRegex(i.description, this.state.search)
    );
    return (
      <Page title="Case Studies">
        <div className="row">
          <SearchWithAction
            className="col-12"
            action="CREATE STUDY CASE"
            onActionClick={() => this.props.push("/studycases/new")}
            onChange={(search) => this.setState({ search })}
            is_admin={this.props.user.is_admin}
          />
        </div>
        <CardBox>
          <Table
            id="studycases"
            renderEmpty={ !!this.state.loading ? () => <Loader /> : this.renderEmpty}
            columns={this.renderChild()}
            data={results}
          />
        </CardBox>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/routers/StudyCases/List.js